// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Allocation } from '@daml.js/splice-api-token-allocation/lib/Splice/Api/Token/AllocationV1';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import InterfaceContract from '../../../../utils/InterfaceContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useAllocations: () => UseQueryResult<InterfaceContract<Allocation>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();

  return useQuery({
    queryKey: ['queryAllocations', offset, ledgerApi],
    queryFn: async () => {
      return ledgerApi.queryAllocations(offset!);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useAllocations;
